import { render, staticRenderFns } from "./TicketUsage.vue?vue&type=template&id=25c4e450&scoped=true&"
import script from "./TicketUsage.vue?vue&type=script&lang=js&"
export * from "./TicketUsage.vue?vue&type=script&lang=js&"
import style0 from "./TicketUsage.vue?vue&type=style&index=0&id=25c4e450&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c4e450",
  null
  
)

export default component.exports